export default {
    'terms.title': '利用規約',
} as Record<string, string>;
